 export const statusPinPad = Object.freeze({
    Nao_Instalado: 'gray',
    Token_Nao_Encontrado: 'yellow',
    TempoEsgotado: 'red',
    Configurado: 'lightgreen'
 })
